import { Component, input } from '@angular/core';
import { RealisationHourtype } from 'src/app/classes/realisation';
import type { RealisationRow } from 'src/app/components/hour-control/hour-control.types';
import { NotApprovablePipe } from 'src/app/pages/check-hours/not-approvable.pipe';
import { NotEditablePipe } from 'src/app/pages/check-hours/not-editable.pipe';
import { AuthorisationService } from 'src/app/services/auth/authorisation.service';
import { EntityTypeCode } from 'src/app/services/entities/entity-type.class';

@Component({
    selector: 'app-realisation-row-name',
    imports: [NotApprovablePipe, NotEditablePipe],
    templateUrl: './realisation-row-name.component.html',
    styleUrl: './realisation-row-name.component.scss',
    host: {
        class: 'd-flex flex-column',
    },
})
export class RealisationRowNameComponent {
    readonly row = input.required<RealisationRow>();

    readonly canApproveHours = AuthorisationService.canApproveHours();

    readonly EntityTypeCode = EntityTypeCode;
    readonly RealisationHourtype = RealisationHourtype;
}
